import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Capacitor + plugin status bar
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

const root = ReactDOM.createRoot(document.getElementById('root'));

// 👉 Si on est dans une app native (iOS/Android)
if (Capacitor.isNativePlatform()) {
  document.body.classList.add("app");

  // Texte/icônes de la barre d'état (iOS + Android)
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {});

  // Ces deux API ne sont implémentées que sur Android (iOS → UNIMPLEMENTED)
  if (Capacitor.getPlatform() === 'android') {
    StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
    StatusBar.setBackgroundColor({ color: '#0f766e' }).catch(() => {});
  }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);